import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfFocusScoreAveragesSummaryApplicationService } from '../../../core/application/services/scores/get-self-focus-score-averages-summary.application-service';
import { SelfFocusScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-focus-score-averages-summary.entity';
import { GetSelfScoreAveragesSummaryRequestDto } from '../../dtos/scores/self-get-score-averages-summary.request.dto';

export class GetSelfFocusScoreAveragesSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfFocusScoreAveragesSummaryApplicationService
  ) {}
  async execute(
    props: GetSelfScoreAveragesSummaryRequestDto
  ): Promise<SelfFocusScoreAveragesSummaryEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
